// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoType } from './contactInfoType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TrialcardSiteV3ModelsSharedContactPreferenceModel {
    'isOptedIn'?: boolean | null;
    'isPreferred'?: boolean | null;
    'contactInfoType'?: ContactInfoType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardSiteV3ModelsSharedContactPreferenceModel>> = [
        {
            "name":     "isOptedIn",
            "baseName": "isOptedIn",
            "type":     "boolean"
        },
        {
            "name":     "isPreferred",
            "baseName": "isPreferred",
            "type":     "boolean"
        },
        {
            "name":     "contactInfoType",
            "baseName": "contactInfoType",
            "type":     "ContactInfoType"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardSiteV3ModelsSharedContactPreferenceModel.attributeTypeMap;
    }
}
